<template>
    <!--<div>-->
        <!--<verification v-if="waitingForReply"/>
        <div v-else>
            <p>Wie möchtest du dich anmelden?{{$t("hello")}}, {{greeting}}</p>
            <v-btn @click="loginGooglePopUp()" class="ma-2" outlined color="indigo">
                GMAIL WITH POPUP
            </v-btn>
        </div>-->
        <v-container fill-height fluid class="grey lighten-4">
            <v-row align="center" justify="center" class="mb-15 pb-15" >
                <v-col class="text-center" cols="10" sm="6" md="3" style="min-width: 340px">
                    <img width="200" src="../../assets/oeskb.png" class="mb-10">
                    <verification v-if="waitingForReply"/>
                    <div v-else>
                        <div v-if="ieBlock">
                            <p>Diese Anwendung läuft leider nicht mehr auf dem veralteten Internet Explorer.</p>
                            <p>Wir empfehlen die Verwendung von Google Chrome, du kannst aber auch jeden anderen
                                modernen Browser nutzen (z.B. Microsoft Edge, Firefox, Opera oder Safari für Apple).</p>
                        </div>
                        <with-e-mail v-else></with-e-mail>
                        <!--<p>{{$t("login.selectMethod")}}</p>-->
                        <!--<v-btn @click="loginGooglePopUp()" class="ma-2" outlined>
                            Sign in with Google
                        </v-btn>-->
                    </div>
                </v-col>
            </v-row>
        </v-container>
    <!--</div>-->
</template>

<script>
    import firebase from 'firebase/app'
    import 'firebase/auth'
    import WithEMail from "./withEMail";
    //import Verification from "./verification";
    export default {
        //components: {Verification},
        components: {WithEMail},
        name: "authentication",
        props: ['ieBlock'],
        data: () => ({
            waitingForReply: false,
        }),
        computed: {
            greeting() {return 'Hallo '}
        },
        methods: {
            loginGooglePopUp() {
                this.waitingForReply = true;
                const provider = new firebase.auth.GoogleAuthProvider();
                firebase.auth().signInWithPopup(provider).then((result) => {
                // This gives you a Google Access Token. You can use it to access the Google API.
                    //this.token = result.credential.accessToken;
                // The signed-in user info.
                    this.$store.commit('user/setFromAuthentication', result.user);
                    this.waitingForReply = false;
                    // ...
                }).catch((error) => {
                // Handle Errors here.
                    console.log (error.code); // auth/operation-not-allowed
                    console.log (error.message); // The identity provider configuration is not found.
                // The email of the user's account used.
                    console.log (error.email);
                // The firebase.auth.AuthCredential type that was used.
                    console.log (error.credential);
                // ...
                    this.waitingForReply = false;
                });
            },
        }
    }
</script>

<style scoped>

</style>